module.exports = __webpack_public_path__ + "static/img/OregonSlopeBase-RA.6f03287.png";